var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { get } from '../utils/funcs';
import Button from './button';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n"], ["\n  display: inline-block;\n  position: relative;\n"])));
var ExpandArrow = styled(FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 0.5em;\n  transform: ", ";\n  transition: transform 200ms ease-in-out;\n"], ["\n  margin-left: 0.5em;\n  transform: ", ";\n  transition: transform 200ms ease-in-out;\n"])), function (p) {
  return p.isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
});
var List = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  list-style: none;\n  margin: 0;\n  margin-top: 1rem;\n  padding: 0;\n  position: absolute;\n  ", "\n  visibility: ", ";\n  z-index: 3;\n\n  &::before {\n    border: 11px solid transparent;\n    border-bottom: 11px solid ", ";\n    color: ", ";\n    content: '';\n    height: 0;\n    margin-top: -10px;\n    position: absolute;\n    ", "\n    top: -12px;\n    width: 0;\n  }\n  &::after {\n    border: 9px solid transparent;\n    border-bottom: 9px solid ", ";\n    content: '';\n    height: 0;\n    margin-top: -11px\n    position: absolute;\n    ", "\n    top: -7px;\n    width: 0;\n  }\n\n  & > :first-child {\n    border-radius: ", " ", " 0 0;\n  }\n\n  & > :last-child {\n    border-radius: 0 0 ", " ", ";\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  list-style: none;\n  margin: 0;\n  margin-top: 1rem;\n  padding: 0;\n  position: absolute;\n  ", "\n  visibility: ", ";\n  z-index: 3;\n\n  &::before {\n    border: 11px solid transparent;\n    border-bottom: 11px solid ", ";\n    color: ", ";\n    content: '';\n    height: 0;\n    margin-top: -10px;\n    position: absolute;\n    ", "\n    top: -12px;\n    width: 0;\n  }\n  &::after {\n    border: 9px solid transparent;\n    border-bottom: 9px solid ", ";\n    content: '';\n    height: 0;\n    margin-top: -11px\n    position: absolute;\n    ", "\n    top: -7px;\n    width: 0;\n  }\n\n  & > :first-child {\n    border-radius: ", " ", " 0 0;\n  }\n\n  & > :last-child {\n    border-radius: 0 0 ", " ", ";\n  }\n"])), function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.level5 : p.theme.level0;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.textPrimary : p.theme.textTertiary;
}, function (p) {
  return p.align + ": 0;";
}, function (p) {
  return p.isOpen ? 'visible' : 'hidden';
}, function (p) {
  return p.invert ? p.theme.colorLevel(p.theme[p.brand ? p.brand : p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.themeName === 'greenlight' ? p.theme.primaryB : p.theme.primary], -5) : p.theme[p.brand ? p.brand : p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.themeName === 'greenlight' ? p.theme.primaryB : p.theme.primary];
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.textPrimary : p.theme.textTertiary;
}, function (p) {
  return p.align + ": 1rem;";
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.level5 : p.theme.level0;
}, function (p) {
  return p.align + ": calc(1rem + 2px);";
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
});
var StyledButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  width: ", ";\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  width: ", ";\n"])), function (p) {
  return p.width ? "calc(" + p.width + "px + 1em)" : '100%';
});
var SelectionText = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var ButtonLike = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n  }\n"])), function (p) {
  return p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' ? p.theme.primaryA : p.theme.themeName === 'greenlight' ? p.theme.primaryA : p.theme.primary;
}); // This is a hacky way to ensure that the dropdown scales to the greatest width
// of all the children. Replace and improve if you have a better way.

var WidthAdjustButton = function WidthAdjustButton(_a) {
  var _b = _a.brand,
      brand = _b === void 0 ? 'primary' : _b,
      header = _a.header,
      widthRef = _a.widthRef,
      onClick = _a.onClick,
      disabled = _a.disabled,
      isOpen = _a.isOpen,
      width = _a.width;
  return React.createElement(StyledButton, {
    buttonRef: widthRef,
    brand: brand,
    disabled: disabled,
    onClick: onClick,
    isOpen: isOpen,
    width: width
  }, React.createElement(SelectionText, null, header), React.createElement(ExpandArrow, {
    icon: faAngleDown,
    isOpen: isOpen,
    fixedWidth: true
  }));
};

var Dropdown =
/** @class */
function (_super) {
  __extends(Dropdown, _super);

  function Dropdown(props) {
    var _this = _super.call(this, props) || this;

    _this.getChildProps = function (child) {
      var _a = _this.props.disabledOptions,
          disabledOptions = _a === void 0 ? [] : _a;
      var childProps = {
        key: get(child, 'props.value') || get(child, 'props.to'),
        selected: get(child, 'props.value') && get(child, 'props.value') === _this.state.selected,
        onClick: !disabledOptions.includes(get(child, 'props.value')) ? _this.selectChild.bind(_this, get(child, 'props.value'), get(child, 'props.onSelect')) : undefined,
        disabled: get(child, 'props.value') && disabledOptions.includes(get(child, 'props.value'))
      };
      return childProps;
    };

    _this.toggle = function () {
      _this.setState(__assign(__assign({}, _this.state), {
        isOpen: !_this.state.isOpen
      }));
    };

    _this.state = {
      childCount: props.children ? React.Children.count(props.children) : 0,
      needsWidth: true,
      isOpen: false,
      selected: props.selected ? props.selected : null,
      width: 0
    };
    _this.widthRef = React.createRef();
    return _this;
  }

  Dropdown.prototype.componentDidMount = function () {
    var node = this.widthRef.current;

    if (this.state.needsWidth && node) {
      this.setState(__assign(__assign({}, this.state), {
        width: node.scrollWidth,
        needsWidth: false
      }));
    }
  };

  Dropdown.prototype.getSelected = function () {
    var _this = this;

    var selectedValues = React.Children.map(this.props.children, function (child) {
      if (get(child, 'props.value', undefined) === _this.state.selected) {
        return get(child, 'props.children');
      }
    });

    if (selectedValues && selectedValues.length === 1) {
      return selectedValues[0];
    } else {
      return this.props.header;
    }
  };

  Dropdown.prototype.selectChild = function (value) {
    var _this = this;

    this.setState(__assign(__assign({}, this.state), {
      selected: value,
      isOpen: false
    }), function () {
      return _this.props.onSelect && _this.props.onSelect(value);
    });
  };

  Dropdown.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        _b = _a.align,
        align = _b === void 0 ? 'right' : _b,
        _c = _a.brand,
        brand = _c === void 0 ? 'primary' : _c,
        children = _a.children,
        _d = _a.disabled,
        disabled = _d === void 0 ? false : _d,
        header = _a.header,
        _e = _a.unstyled,
        unstyled = _e === void 0 ? false : _e,
        props = __rest(_a, ["align", "brand", "children", "disabled", "header", "unstyled"]);

    return React.createElement(Wrapper, {
      className: "dropdown"
    }, unstyled ? React.createElement(ButtonLike, Object.assign({
      isOpen: this.state.isOpen
    }, props, {
      onClick: this.toggle
    }), header) : React.createElement(React.Fragment, null, this.state.needsWidth && React.createElement(WidthAdjustButton, {
      widthRef: this.widthRef,
      brand: brand,
      header: header,
      disabled: disabled,
      onClick: this.toggle,
      isOpen: this.state.isOpen,
      width: this.state.width
    }), !this.state.needsWidth && React.createElement(StyledButton, Object.assign({
      brand: brand,
      disabled: disabled,
      onClick: this.toggle,
      isOpen: this.state.isOpen,
      width: this.state.width
    }, props), React.createElement(SelectionText, null, this.getSelected()), React.createElement(ExpandArrow, {
      icon: faAngleDown,
      isOpen: this.state.isOpen,
      fixedWidth: true
    }))), !disabled && React.createElement(List, {
      className: "dropdown-list",
      align: align,
      isOpen: this.state.isOpen
    }, React.Children.map(children, function (child) {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, _this.getChildProps(child));
      }
    })));
  };

  return Dropdown;
}(React.Component);

export default Dropdown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;